import styled from 'styled-components';

import { TooltipContainer } from '~/shared/components/tooltip-container/TooltipContainer';

export const InputTooltip = styled(TooltipContainer)`
  z-index: 101;
`;
